import React, { Component, Fragment } from "react";
import {
  DeleteResponseModel,
  LinkResourcesResponseModel,
} from "../../../../../../shared/models";
import { ExtractorRateLimitService } from "./services/extractor.rate.limit.service";
import { HttpResponse } from "../../../../../../core";
import {
  ShowSuccessMessage,
  HandleNotFoundResponse,
} from "../../../../../../shared/helpers";
import { ExtractorRateLimitsTabs } from "./ExtractorRateLimitsTabs";
import { NavLink } from "react-router-dom";
import {
  ButtonType,
  NotFoundResponseArea,
} from "../../../../../../shared/enums";

interface IState {
  result?: LinkResourcesResponseModel;
  deleteResult?: DeleteResponseModel;
  isDoubleleClick?: boolean;
}
export class DeleteExtractorRateLimit extends Component<any, IState> {
  private service: ExtractorRateLimitService;
  constructor(props) {
    super(props);
    this.state = this.initialState;
    this.service = new ExtractorRateLimitService();
    this.deleteRecord = this.deleteRecord.bind(this);
  }

  initialState: Partial<IState> = {
    result: {
      id: 0,
      name: "",
    },
    deleteResult: { isdeleted: false },
    isDoubleleClick: false,
  };

  componentDidMount() {
    this.loadData();
  }

  loadData() {
    this.service
      .getLinkedResourcesById(this.props.match.params.id)
      .then((res: HttpResponse<LinkResourcesResponseModel>) => {
        if (res && res.result) {
          this.setState({
            result: res.result
          });
        }
      })
      .catch((ex) => {
        HandleNotFoundResponse(
          ex,
          NotFoundResponseArea.Extractor_Rate_Limit,
          this.props
        );
      });
  }

  deleteRecord() {
    if (!this.state.isDoubleleClick) {
      this.setState({ isDoubleleClick: true });
      this.service
        .deleteExtractorRateLimitById(this.props.match.params.id)
        .then((res: HttpResponse<DeleteResponseModel>) => {
          if (res && res.result) {
            this.setState(
              {
                deleteResult: res.result
              },
              () => {
                if (this.state.deleteResult?.isdeleted) {
                  ShowSuccessMessage(
                    "Extractor Rate Limit Successfully Deleted."
                  );
                  this.props.history.push("/extractor-rate-limit/list");
                }
              }
            );
          }
        });
    }
  }
  render() {
    return (
      <Fragment>
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h5>
            Delete Extractor Rate Limit 'ExtractorRateLimit #
            {this.props.match.params.id}'
          </h5>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                <ExtractorRateLimitsTabs
                  id={this.props.match.params.id}
                  url="/extractor-rate-limit/delete/"
                />
                <div className="alert font-weight-bold  alert-light">
                  {" "}
                  <i className="fas fa-exclamation-circle text1"></i> Are you
                  sure you want to delete this Extractor Rate Limit{" "}
                  <strong>"#{this.props.match.params.id}”</strong> ?
                </div>

                <p className="mt-4 text-danger">
                  <i className="fas fa-exclamation-triangle text1"></i> The
                  following related items may be deleted or orphaned:
                </p>
                <div className="row ">
                  <div className="col-4">
                    <div className="card card-primary shadow-sm">
                      <div className="card-header">
                        <h4>Extractor Rate Limit</h4>
                      </div>
                      <div className="card-body">
                        <NavLink
                          className="badge badge-light text-link"
                          to={
                            "/extractor-rate-limit/detail/" +
                            this.props.match.params.id
                          }
                        >
                          ExtractorRateLimit #{this.props.match.params.id}
                        </NavLink>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mb-4">
              <div className="mx-auto">
                <button
                  className="btn btn-lg btn-danger"
                  disabled={this.state.isDoubleleClick}
                  onClick={this.deleteRecord}
                >
                  {" "}
                  {ButtonType.Delete}
                </button>
                <NavLink
                  type="button"
                  className="btn btn-lg btn-default ml-3"
                  to="/extractor-rate-limit/list"
                >
                  {ButtonType.Cancel}
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
